import { deleteFile } from "helpers/fileHelper";
import { FileableFile, UploadFile } from "types/storage.types";
import { FileUploadType } from "./types/FileUpload.types";
import { AllowedFileType } from "./types/AllowedFileType.types";
import { MIME_MAP } from "./constants/acceptedFileTypes";
import { UploadedFile } from "./types/UploadedFile.type";
import { UploadStatus } from "./types/UploadStatus.type";

export const deleteFileUpload = async (
	file: UploadFile,
	fileUploadType: FileUploadType
) => {
	try {
		await deleteFile(file.id, fileUploadType, file.file_path);

		return { success: true, file: file };
	} catch (error) {
		return { success: false, file: file };
	}
};

/**
 * Validates the uploaded file against name length and size restrictions
 * @param file
 * @param options
 * @returns
 */
export function validateFile(
	file: File,
	options: {
		maxSizeMB?: number;
		maxNameLength?: number;
	}
): string | null {
	if (options.maxSizeMB && file.size > options.maxSizeMB * 1024 * 1024) {
		return `Max file size is ${options.maxSizeMB}MB`;
	}

	if (options.maxNameLength && file.name.length > options.maxNameLength) {
		return `Filename too long`;
	}

	return null;
}

export const getFileMimeRecords = (types: AllowedFileType[]) => {
	const result = types.reduce<Record<string, string[]>>((acc, type) => {
		Object.assign(acc, MIME_MAP[type]);
		return acc;
	}, {});

	return result;
};

export const convertFileAbleFileToUploadedFile = (
	file: FileableFile
): UploadedFile => {
	if (!file) {
		return null;
	}

	return {
		id: file.id,
		name: file.file_name,
		path: file.file_path,
		status: UploadStatus.UPLOADED,
		size: file.file_size,
	};
};
